module.exports = __webpack_public_path__ + "img/table.d7a94d3b.svg";